import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  View,
  Button,
  StyleSheet,
  Image,
  Text,
  Dimensions,
  TouchableOpacity,
} from "react-native";
import { Camera, CameraView, useCameraPermissions } from "expo-camera";
import Slider from "@react-native-community/slider"; // Correct import

import * as ImageManipulator from "expo-image-manipulator";
import * as MediaLibrary from "expo-media-library";
import { commonStyles } from "../styles";
import { Icon } from "react-native-elements";

type CameraScreenProps = {
  onClear: () => void;
  onTakePhoto: (img: string) => void;
};

const CameraScreen = ({ onClear, onTakePhoto }: CameraScreenProps) => {
  const cameraRef = useRef<any>(null); // useRef<any> for the camera reference
  const [permissionStatus, requestPermission] = useCameraPermissions();
  const [photo, setPhoto] = useState<string | null>(null);
  const [zoom, setZoom] = useState(0);

  useEffect(() => {
    requestPermission(); // Request camera permission
    MediaLibrary.requestPermissionsAsync();
  }, []);

  const clearPicture = () => {
    setPhoto(null);
  };

  useEffect(() => {}, []);

  const takePicture = async () => {
    if (cameraRef.current) {
      const {
        uri,
        width: imageWidth,
        height: imageHeight,
      } = await cameraRef.current.takePictureAsync({
        base64: true,
      });

      // Crop the image based on overlay dimensions
      const croppedPhoto = await ImageManipulator.manipulateAsync(uri, [], {
        compress: 1,
        format: ImageManipulator.SaveFormat.JPEG,
      });
      // Save the cropped image to the camera roll
      try {
        const asset = await MediaLibrary.createAssetAsync(croppedPhoto.uri);
        if (asset) {
          // could do a notification that photo was saved
          // Alert.alert('Photo saved!', 'Your photo has been saved to the camera roll.');
        }
      } catch (error) {
        console.log(error);
      }

      onTakePhoto(croppedPhoto.uri);

      // Convert cropped image to Base64 string
      const base64String = await fetch(croppedPhoto.uri)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            })
        );

      // setPhoto(base64String as string); // Set the Base64 string to state
      onTakePhoto(base64String as string);
    }
  };

  if (!permissionStatus) {
    return <View />;
  }
  if (permissionStatus.status !== "granted") {
    return <Text style={styles.errorText}>No access to camera</Text>;
  }

  const handleZoom = (value: any) => {
    setZoom(value);
  };

  return (
    <View style={styles.container}>
      <View
        style={{
          position: "absolute",
          top: -200,
          margin: "auto",
          width: "100%",
        }}
      >
        <View style={commonStyles.infoBox}>
      <Text style={commonStyles.title}>Counter Vision</Text>
      <Text style={commonStyles.description}>Take a photo of the enemy team</Text>
    </View>
      </View>
      <View
        style={{
          position: "absolute",
          bottom: -200,
          margin: "auto",
          width: "100%",
        }}
      >
        <Slider
          style={{ position: "relative", width: "90%", alignSelf: "center" }}
          minimumValue={0}
          maximumValue={1}
          value={zoom}
          onValueChange={handleZoom}
          step={0.01}
        />
      </View>

      <CameraView style={styles.camera} ref={cameraRef} zoom={zoom}>
        {/* <View style={[styles.overlay, { width: overlaySize, height: overlaySize, top: (height - overlaySize) / 2, left: (width - overlaySize) / 2 }]} /> */}
      </CameraView>

      {/* {photo && (
        <Image source={{ uri: photo }} style={styles.image} />
      )} */}
      <View
        style={{
          position: "absolute",
          bottom: -100,
          margin: "auto",
          width: "100%",

        }}
      >
        <TouchableOpacity onPress={takePicture} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderWidth :2, borderColor:'#5aaafa', margin: 'auto', padding: 10, borderRadius: "50%", backgroundColor: '#ffffff'}}>
          <Icon name="camera" type='font-awesome' color={'#5aaafa'} size={38}/> 
          {/* <Text style={{fontFamily: 'NinjaTurtles'}}>Take Photo</Text> */}
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "#ccc",
  },
  camera: {
    flex: 1,
    justifyContent: "flex-end",
  },
  overlay: {
    position: "absolute",
    borderColor: "red",
    borderWidth: 3,
    backgroundColor: "transparent",
  },

  errorText: {
    textAlign: "center",
    marginTop: 20,
    color: "red",
  },
});

export default CameraScreen;
